import { useState } from 'react'

import { FiInfo, FiX } from 'react-icons/fi'

const LEGEND_STORAGE_KEY = 'map-legend-visible'

const getStoredVisibility = (): boolean => {
  try {
    const stored = localStorage.getItem(LEGEND_STORAGE_KEY)
    return stored === null ? true : stored === 'true'
  } catch {
    return true
  }
}

const setStoredVisibility = (visible: boolean) => {
  try {
    localStorage.setItem(LEGEND_STORAGE_KEY, String(visible))
  } catch {
    // localStorage not available
  }
}

export const Legend = () => {
  const [showLegend, setShowLegend] = useState(getStoredVisibility)

  const toggleLegend = (visible: boolean) => {
    setShowLegend(visible)
    setStoredVisibility(visible)
  }

  if (showLegend) {
    return (
      <div className="absolute bottom-16 md:bottom-4 right-4 z-10 bg-base-100 rounded-lg shadow-lg p-4 border border-base-300">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-semibold text-sm">Legend</h3>
          <button
            onClick={() => toggleLegend(false)}
            className="btn btn-ghost btn-xs btn-square"
            aria-label="Close legend"
          >
            <FiX className="w-4 h-4" />
          </button>
        </div>
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <img src="/images/critical-marker.webp" width="32" />
            <span className="text-sm">Critical Alarms</span>
          </div>
          <div className="flex items-center gap-2">
            <img src="/images/warning-marker.webp" width="32" />
            <span className="text-sm">Warning Alarms</span>
          </div>
          <div className="flex items-center gap-2">
            <img src="/images/info-marker.webp" width="32" />
            <span className="text-sm">Informational Alarms</span>
          </div>
          <div className="flex items-center gap-2">
            <img src="/images/default-marker.webp" width="32" />
            <span className="text-sm">No Active Alarms</span>
          </div>
          <div className="flex items-center gap-2">
            <img src="/images/offline-marker.webp" width="32" />
            <span className="text-sm">Gateway Offline</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-full bg-blue-500 border-2 border-white flex items-center justify-center ml-0.5">
              <span className="text-white text-xs font-bold">7</span>
            </div>
            <span className="text-sm">Multiple Assets - Click to Zoom</span>
          </div>
        </div>
      </div>
    )
  }

  const DesktopLegend = () => (
    <>
      <button
        onClick={() => toggleLegend(true)}
        className="tooltip tooltip-top tooltip-primary absolute bottom-4 right-4 z-10 btn btn-sm bg-base-100 shadow-lg  items-center pl-2 pr-4 hidden md:flex"
        data-tip="Show Legend"
      >
        <FiInfo className="w-4 h-4 mr-1" />
        Legend
      </button>
    </>
  )

  const MobileLegend = () => (
    <>
      <button
        onClick={() => toggleLegend(true)}
        className="tooltip tooltip-top tooltip-primary absolute bottom-16 right-4 z-10 btn  bg-base-100 shadow-lg flex items-center btn-circle "
        data-tip="Show Legend"
      >
        <FiInfo className="w-4 h-4 " />
      </button>
    </>
  )

  return (
    <>
      <DesktopLegend />
      <MobileLegend />
    </>
  )
}
